import "@/App.css";
import { BookingProvider } from "@/components/BookingContext";
import { BookingModal } from "@/components/BookingModal";
import { Nav } from "@/components/Nav";
import { Hero } from "@/sections/Hero";
import { Ticker } from "@/sections/Ticker";
import { Weight } from "@/sections/Weight";
import { HowItWorks } from "@/sections/HowItWorks";
import { MathSection } from "@/sections/MathSection";
import { Proof } from "@/sections/Proof";
import { Industries } from "@/sections/Industries";
import { Pricing } from "@/sections/Pricing";
import { WhoRunsIt } from "@/sections/WhoRunsIt";
import { Close } from "@/sections/Close";
import { Footer } from "@/sections/Footer";

function App() {
    return (
        <BookingProvider>
            <div className="App relative">
                <Nav />
                <main>
                    <Hero />
                    <Ticker />
                    <Weight />
                    <HowItWorks />
                    <MathSection />
                    <Proof />
                    <Industries />
                    <Pricing />
                    <WhoRunsIt />
                    <Close />
                </main>
                <Footer />
                <BookingModal />
            </div>
        </BookingProvider>
    );
}

export default App;
